export function getWindowUrl(): string {
  const url = window.__GET_WINDOW_URL__;
  if (!url) {
    throw new Error('__GET_WINDOW_URL__ is not defined');
  }
  return url;
}
